<template>

        <div class="columns has-text-centered justify-center">
            <div style="width: 400px;height: 400px;" class="resetcss">
            <pie-chart :label="test"/>
            </div>
        </div>

</template>

<script>
    export default {

        props: {
            pieChartData: {
                type: Object,
                // eslint-disable-next-line vue/require-valid-default-prop
                default: {}
            }
        },
        data() {
            return {
                test: ["asdasd", "xcvxcv", "qweqwe"]
            }
        },
        created() {
        }

    }
    import Vue from "vue";
    import VueChartJs from "vue-chartjs";

    Vue.component('pie-chart', {
        props: {
            label: Array
        },
        extends: VueChartJs.Pie,
        mounted () {
            this.renderChart({
                labels: this.label,
                datasets: [
                    {
                        backgroundColor: ["#41B883", "#E46651", "#3273d6"],
                        data: [29, 12, 1]
                    }
                ]
            }, {responsive: true, maintainAspectRatio: false})
        }

    })

</script>
<style>
    .resetcss {
        all: unset !important;
    }
</style>
